import type { MembershipRole, UserMainRole } from "@zplanem/responses"

/**
 * Roles that can appear next to a chat message author. `owner` and `ai` are
 * not values of any DTO role enum — they're synthesized client-side from the
 * memberships fetch (owner = property.owner) and `chat_messages.actorType`
 * (ai = Mareczek).
 */
export type ChatRole = "owner" | MembershipRole | "ai"

/** Tailwind text-color class for the top-nav `mainRole` chip. */
export function mainRoleTextClass(role: UserMainRole): string {
	switch (role) {
		case "investor":
			return "text-amber-600 dark:text-amber-400"
		case "contractor":
			return "text-red-600 dark:text-red-400"
		case "architect":
			return "text-blue-600 dark:text-blue-400"
	}
}

/**
 * Tailwind border-color class for the chat avatar ring. The avatar itself
 * is transparent-bg + white-text — only the ring varies per role. Returns
 * an empty string for `"ai"`; that case is rendered by `MareczekAvatar`
 * instead of the generic `AuthorAvatar`, so no border class is needed.
 */
export function chatRoleBorderClass(role: ChatRole): string {
	switch (role) {
		case "owner":
			return "border-emerald-500/30"
		case "member":
			return "border-amber-400/30"
		case "contractor":
			return "border-red-500/30"
		case "architect":
			return "border-blue-500/30"
		case "ai":
			return ""
	}
}
